__turbopack_context__.v({
  "slide": "LFGSlideshow-module-scss-module__cMniUq__slide",
  "slideButton": "LFGSlideshow-module-scss-module__cMniUq__slideButton",
  "slideButtons": "LFGSlideshow-module-scss-module__cMniUq__slideButtons",
  "slideshowContainer": "LFGSlideshow-module-scss-module__cMniUq__slideshowContainer",
});
